import React from "react";
import Box from "@mui/material/Box";
import {SanitizedHtml} from "./SanitizedHtml";

/**
 * Renders sanitized HTML content wrapped in Nordic Calm typography prose styling.
 * Applies consistent heading colors, readable line-heights, blockquote callouts, and links.
 */
export const ProseArticle = ({html}) => {
    return (
        <Box
            sx={{
                color: "text.primary",
                lineHeight: 1.8,
                overflowWrap: "anywhere",
                wordBreak: "break-word",
                "& h1": {
                    fontSize: {xs: "1.6rem", sm: "2rem"},
                    fontWeight: 800,
                    color: "primary.main",
                    letterSpacing: "-0.01em",
                    mt: 3,
                    mb: 2,
                },
                "& h2": {
                    fontSize: {xs: "1.35rem", sm: "1.6rem"},
                    fontWeight: 700,
                    color: "primary.main",
                    letterSpacing: "-0.01em",
                    mt: 3.5,
                    mb: 1.5,
                    borderBottom: "1px solid",
                    borderColor: "rgba(40, 82, 56, 0.12)",
                    pb: 1,
                },
                "& h3": {
                    fontSize: {xs: "1.15rem", sm: "1.3rem"},
                    fontWeight: 700,
                    color: "text.primary",
                    mt: 2.5,
                    mb: 1,
                },
                "& p": {
                    fontSize: {xs: "0.975rem", sm: "1.05rem"},
                    lineHeight: 1.8,
                    color: "text.secondary",
                    mb: 2,
                },
                "& ul, & ol": {
                    pl: 3,
                    mb: 2,
                    color: "text.secondary",
                    fontSize: {xs: "0.975rem", sm: "1.05rem"},
                    lineHeight: 1.8,
                },
                "& li": {
                    mb: 0.75,
                },
                "& blockquote": {
                    borderLeft: "4px solid",
                    borderColor: "primary.main",
                    bgcolor: "rgba(40, 82, 56, 0.04)",
                    py: 1.5,
                    px: 2.5,
                    my: 2.5,
                    borderRadius: "0 8px 8px 0",
                    fontStyle: "italic",
                    color: "text.primary",
                },
                "& strong": {
                    color: "text.primary",
                    fontWeight: 700,
                },
                "& a": {
                    color: "primary.main",
                    textDecoration: "underline",
                    fontWeight: 600,
                    "&:hover": {
                        color: "primary.dark",
                    },
                },
                "& img": {
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: 2,
                    my: 2,
                },
            }}
        >
            <SanitizedHtml html={html} />
        </Box>
    );
};
